export enum DialogSize {
  Medium = '516px',
  Wide = '696px',
  Large = '767px',
}
